module.exports = __webpack_public_path__ + "img/notification-coins.b9cf9cf4.png";